import React, { useState, useEffect } from 'react';

import { api } from '../../core/services';
import { GalleryUpload } from '../../components';

const shouldUpdateImages = (product, images) => {
  if (images.length !== product.images.length) {
    return true;
  }

  for (let index = 0; index < images.length; index += 1) {
    if (product.images[index].id != images[index]) {
      return true;
    }
  }

  return false;
}

const saveChanges = async (product, images, setIsSaving) => {
  try {
    if (!shouldUpdateImages(product, images)) {
      return;
    }

    setIsSaving(true);

    const newImages = await api.put(`/api/products/${product.id}/images`, {
      images,
    });
    product.images = newImages;

    setIsSaving(false);
  } catch (error) {
    console.log('err', error);
  }
};

const EditProductImages = ({ product }) => {
  const [value, setValue] = useState(product.images.map(prod => prod.id));
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isSaving) {
      return;
    }

    saveChanges(product, value, setIsSaving);
  }, [value]);

  return (
    <div className="field-group field-group-galleryUpload mt-0">
      <GalleryUpload
        {...{
          onChange: setValue,
          value,
        }}
      />
    </div>
  );
}

export default EditProductImages;
